<template>
  <div class="container">
    <el-row :gutter="10">
        <filter-wrapper
          :filter-item="{
          searchBox: true,
            machine: true,
            canteen: true,
            eatery: true,
            dateRange: true
          }"
        ></filter-wrapper>
    </el-row>
    <div class="container-wrapper">
      <div  class="btn-wrapper">
        <el-checkbox v-model="filter[0]" >早餐</el-checkbox>
        <el-checkbox v-model="filter[1]" >午餐</el-checkbox>
        <el-checkbox v-model="filter[2]" >晚餐</el-checkbox>
        <el-checkbox v-model="filter[3]" >总计</el-checkbox>
        <el-button type="primary" @click="getEventLsit" size="mini">查询</el-button>
        <el-button type="primary" @click="exportExcel" size="mini">生成excel</el-button>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="旧版事件" name="old">
          <el-table :height="tableHight" id="out-table-old" :data="flattenEventList"
                          style="width: 70%;display: inline-block;vertical-align: top; margin-right: 10px">
          <el-table-column prop="dateTimeNode" header-align="center"
                           align="center" label="事件节点">
          </el-table-column>
          <el-table-column
            label="触发次数"
            header-align="center"
            align="center"
          >
            <el-table-column
              header-align="center"
              align="center"
              label="关闭软件"
            >
              <template slot-scope="scope">
                {{scope.row.close_app.length}}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="打开软件"
            >
              <template slot-scope="scope">
                {{scope.row.open_app.length}}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label=完成交易
            >
              <template slot-scope="scope">
                {{scope.row.pay_finished.length}}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="finish_manul"
              label="完成交易(人工介入)"
            >
              <template slot-scope="scope">
                {{scope.row.pay_finished_manually.length}}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="finish_manul"
              label="人工干预率"
            >
              <template slot-scope="scope">
                {{manuallyRate(scope.row)}}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        </el-tab-pane>
        <el-tab-pane label="新版事件" name="new">
          <el-table
            id="out-table-new"
            :data="persantList"
            :height="tableHight"
            style="width: 70%">
            <el-table-column
              label="日期"
              header-align="center"
              align="center">
              <template slot-scope="scope">
                {{scope.row.date | tsToDate}}
              </template>
            </el-table-column>
            <el-table-column
              label="餐时"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag type="danger" v-if="scope.row.type === 1" size="mini">早餐</el-tag>
                <el-tag type="primary" v-if="scope.row.type === 2" size="mini">午餐</el-tag>
                <el-tag type="warning" v-if="scope.row.type === 3" size="mini">晚餐</el-tag>
                <el-tag type="success" v-if="scope.row.type === 3" size="mini">总计</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="total"
              header-align="center"
              align="center"
              label="完成订单/单">
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="manual"
              label="介入单数/单"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="columnProp"
              label="介入入率"
            >
              <template slot-scope="scope">
                {{scope.row.persant * 100 + '%'}}
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-card class="time-card" style="width: 20%;display: inline-block">
          <div slot="header" class="clearfix">
            <span>餐时时间段</span>
            <!--<el-button style="float: right; padding: 3px 0" type="text">更新</el-button>-->
          </div>
          <el-form ref="form" :model="mealTime" label-width="80px">
            <el-form-item label="早餐">
              <el-col :span="10">
                <el-input v-model="mealTime.breakfast[0]" placeholder="placeholder"></el-input>
              </el-col>
              <el-col :span="1">~</el-col>
              <el-col :span="10">
                <el-input v-model="mealTime.breakfast[1]" placeholder="placeholder"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="午餐">
              <el-col :span="10">
                <el-input v-model="mealTime.lunch[0]" placeholder="placeholder"></el-input>
              </el-col>
              <el-col :span="1">~</el-col>
              <el-col :span="10">
                <el-input v-model="mealTime.lunch[1]" placeholder="placeholder"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="晚餐">
              <el-col :span="10">
                <el-input v-model="mealTime.dinner[0]" placeholder="placeholder"></el-input>
              </el-col>
              <el-col :span="1">~</el-col>
              <el-col :span="10">
                <el-input v-model="mealTime.dinner[1]" placeholder="placeholder"></el-input>
              </el-col>
            </el-form-item>
          </el-form>
        </el-card>
    </div>
  </div>
</template>
<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';

import filterWrapper from '_c/filterWrapper';
import {mapGetters, mapMutations} from 'vuex';
import {apiGetAllEvents, apiQueryEventsByMachineId, apiGetManualPersant} from '@/api';
import moment from 'moment';

export default {
  name: 'eventManagement',
  components: {
    filterWrapper
  },
  data () {
    return {
      persantList: [
        {
          date: 1524512400,
          type: 1,
          persant: 0.1,
          total: 100,
          manual: 10
        },
        {
          date: 1524512400,
          type: 1,
          persant: 0.1,
          total: 100,
          manual: 10
        },
        {
          date: 1524512400,
          type: 1,
          persant: 0.1,
          total: 100,
          manual: 10
        },
        {
          date: 1524512400,
          type: 1,
          persant: 0.1,
          total: 100,
          manual: 10
        }
      ],
      activeName: 'new',
      eventCountByMachine: [],
      eventsClass: [],
      mealTime: {
        breakfast: ['6:30', '10:30'],
        lunch: ['10:30', '14:30'],
        dinner: ['16:00', '19:30']
      },
      filter: [true, true, true, true]
    };
  },
  mounted () {
    this.setSubTitle('事件管理');
    this.getEventLsit();
    this.getManualPersant();
  },
  filters: {
    tsToDate (ts) {
      return moment(ts * 1000).format('YYYY-MM-DD');
    }
  },
  methods: {
    ...mapMutations(['setSubTitle', 'emitLoading', 'removeLoading']),
    async getManualPersant () {
      try {
        const res = await apiGetManualPersant([
          {
            machine_id: this.listQuery.machine.machine_id,
            date: this.tsRange
          }
        ]);
        this.persantList = [
          {
            date: 1524512400,
            type: 1,
            persant: 0.1,
            total: 100,
            manul: 10
          },
          {
            date: 1524512400,
            type: 1,
            persant: 0.1,
            total: 100,
            manul: 10
          },
          {
            date: 1524512400,
            type: 1,
            persant: 0.1,
            total: 100,
            manul: 10
          },
          {
            date: 1524512400,
            type: 1,
            persant: 0.1,
            total: 100,
            manul: 10
          }
        ];
        console.log(res);
      } catch (e) {
        console.log(e);
      }
    },
    tsTodatetime (ts) {
      return moment(ts).format('YYYY-MM-DD HH:MM:SS');
    },
    manuallyRate (row) {
      // eslint-disable-next-line
      if (row.pay_finished_manually == 0 || row.pay_finished == 0) {
        return 0;
      } else {
        return (row.pay_finished_manually.length * 100 / row.pay_finished.length).toFixed(4) + '%';
      }
    },
    exportExcel () {
      this.emitLoading();
      let wb = XLSX.utils.table_to_book(document.querySelector(`#out-table-${this.activeName}`));
      let wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'eventSummary.xlsx');
        this.removeLoading();
      } catch (e) {
      }
    },
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '人工干预率';
          return;
        }
        sums[index] = this.computedRateData[index - 1];
      });
      return sums;
    },
    computedCount (row) {
      console.log(row);
      // let key = row.event_id;
      let tsArr = row;
      // if (this.eventCountByMachine[key]) {
      //   tsArr = this.eventCountByMachine[key];
      // }
      if (!row) {
        return {
          breakfast: [],
          lunch: [],
          dinner: [],
          count: 0
        };
      }
      let obj = {
        breakfast: [],
        lunch: [],
        dinner: [],
        count: tsArr.length
      };
      tsArr.forEach((ts) => {
        let res = moment(ts).hour() * 60 + moment(ts).minute();
        // 6:00 ~~~ 10:30
        if (res > this.computedMealNum.breakfast[0] && res < this.computedMealNum.breakfast[1]) {
          obj.breakfast.push(ts);
        } else if (res > this.computedMealNum.lunch[0] && res < this.computedMealNum.lunch[1]) {
          obj.lunch.push(ts);
        } else if (res > this.computedMealNum.dinner[0] && res < this.computedMealNum.dinner[1]) {
          obj.dinner.push(ts);
        }
      });
      return obj;
    },
    async getEventLsit () {
      try {
        this.emitLoading();
        this.eventsClass = await apiGetAllEvents();
        this.eventCountByMachine = await apiQueryEventsByMachineId({
          machine_id: this.machineId,
          // machine_id: 55,
          time_range: this.dateList
        });
        setTimeout(() => {
          this.removeLoading();
        }, 200);
      } catch (e) {
        setTimeout(() => {
          this.removeLoading();
        }, 200);
      }
    }
  },
  computed: {
    ...mapGetters(['listQuery']),
    tsRange () {
      return this.listQuery.dateRange.map(a => moment(a).startOf('date').valueOf() / 1000);
    },
    tableHight () {
      const clientHeight = window.innerHeight;
      return clientHeight - 150;
    },
    machineId () {
      return this.listQuery.machine.machine_id;
    },
    filterToNum () {
      let _arr = this.filter.map(item => {
        console.log(item);
        return item ? '1' : '0';
      });
      let count = '';
      _arr.forEach(a => {
        count += a;
      });
      return count;
    },
    // eslint-disabled
    flattenEventList () {
      let _flattenList = this.$_.flatten(this.eventListByMealTime);
      let arr = [];
      switch (this.filterToNum) {
        case '0000':
          return [];
        case '0001':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('合') !== -1;
          });
        case '0010':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('晚') !== -1;
          });
        case '0011':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('晚') !== -1 || item.dateTimeNode.indexOf('合') !== -1;
          });
        case '0100':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('午') !== -1;
          });
        case '0101':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('午') !== -1 || item.dateTimeNode.indexOf('合');
          });
        case '0110':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('午') !== -1 || item.dateTimeNode.indexOf('晚') !== -1;
          });
        case '0111':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('午') !== -1 || item.dateTimeNode.indexOf('晚') !== -1 ||
              item.dateTimeNode.indexOf('合') !== -1;
          });
        case '1000':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('早') !== -1;
          });
        case '1001':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('早') !== -1 || item.dateTimeNode.indexOf('合') !== -1;
          });
        case '1010':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('早') !== -1 || item.dateTimeNode.indexOf('晚') !== -1;
          });
        case '1011':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('早') !== -1 || item.dateTimeNode.indexOf('晚') !== -1 ||
            item.dateTimeNode.indexOf('合');
          });
          // case '1011':
          // return _flattenList.filter(item => {
          //   return item.dateTimeNode.indexOf('早') !== -1 || return item.dateTimeNode.indexOf('晚') !== -1 || return
          //   item.dateTimeNode.indexOf('合') ;
          // });
        case '1100':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('早') !== -1 || item.dateTimeNode.indexOf('午') !== -1;
          });
        case '1101':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('早') !== -1 || item.dateTimeNode.indexOf('午') !== -1 ||
              item.dateTimeNode.indexOf('合') !== -1;
          });
        case '1110':
          return _flattenList.filter(item => {
            return item.dateTimeNode.indexOf('早') !== -1 || item.dateTimeNode.indexOf('午') !== -1 ||
              item.dateTimeNode.indexOf('晚') !== -1;
          });
        case '1111':
          return _flattenList;
      }
      // return this.$_.flatten(arr);
    },
    eventListByMealTime () {
      let eventList = Object.values(this.eventCountByMachine);
      let dateList = this.dateList;
      function Obj (dateTimeNode, open_app = [], close_app = [], pay_finished = [], pay_finished_manually = []) {
        return {dateTimeNode, open_app, close_app, pay_finished, pay_finished_manually};
      }
      let arr = [];
      eventList.forEach((dateEvent, index) => {
        let date = moment(dateList[index]).format('M.D');
        if (!dateEvent) {
          arr.push(
            [
              new Obj(date + '早餐'),
              new Obj(date + '午餐'),
              new Obj(date + '晚餐'),
              new Obj('合计')
            ]
          );
        } else {
          let keys = ['open_app', 'close_app', 'pay_finished', 'pay_finished_manually'];
          let mealCount = keys.map((key) => {
            return this.computedCount(dateEvent[key]);
          });
          // arr.push(
          //   [
          //     new Obj(date + '早餐', )
          //   ]
          // )
          arr.push(
            [
              new Obj(date + '早餐', mealCount[0].breakfast, mealCount[1].breakfast, mealCount[2].breakfast, mealCount[3].breakfast),
              new Obj(date + '午餐', mealCount[0].lunch, mealCount[1].lunch, mealCount[2].lunch,
                mealCount[3].lunch),
              new Obj(date + '晚餐', mealCount[0].dinner, mealCount[1].dinner, mealCount[2].dinner,
                mealCount[3].dinner),
              new Obj('合计',
                [...mealCount[0].breakfast, ...mealCount[0].lunch, ...mealCount[0].dinner],
                [...mealCount[1].breakfast, ...mealCount[1].lunch, ...mealCount[1].dinner],
                [...mealCount[2].breakfast, ...mealCount[2].lunch, ...mealCount[2].dinner],
                [...mealCount[3].breakfast, ...mealCount[3].lunch, ...mealCount[3].dinner])
            ]);
        }
      });
      arr = arr.sort((a, b) => {
        let reg = /^([0-9]{1,}[.][0-9]*)/g;
        console.log(-a[0].dateTimeNode.match(reg)[0], b[0].dateTimeNode.match(reg)[0]);
        return -a[0].dateTimeNode.match(reg)[0] + Number(b[0].dateTimeNode.match(reg)[0]);
      });
      return arr;
    },
    dateList () {
      let dateRange = this.listQuery.dateRange;
      let [start_ts, end_ts] = dateRange;
      start_ts = moment(start_ts);
      end_ts = moment(end_ts);
      let current_ts = start_ts;
      let dateList = [];
      while (!(current_ts > end_ts)) {
        dateList.push(current_ts.startOf('date').valueOf());
        current_ts = current_ts.add(1, 'd');
      }
      return dateList;
    },
    computedMealNum () {
      let mealTime = this.mealTime;
      let keys = Object.keys(mealTime);
      let obj = {};
      keys.forEach((key) => {
        let arr = mealTime[key];
        arr = arr.map(a => {
          return Number(a.split(':')[0] * 60) + Number(a.split(':')[1]);
        });
        this.$set(obj, key, arr);
      });
      return obj;
    },
    computedRateData () {
      let data = this.eventCountByMachine;
      let finishData = data.pay_finished || [];
      let finishDataManually = data.pay_finished_manually || [];
      let obj = {
        breakfast: [],
        lunch: [],
        dinner: []
      };
      let obj1 = {
        breakfast: [],
        lunch: [],
        dinner: []
      };
      finishDataManually.forEach((ts) => {
        let res = moment(ts).hour() * 60 + moment(ts).minute();
        // 6:00 ~~~ 10:30
        if (res > this.computedMealNum.breakfast[0] && res < this.computedMealNum.breakfast[1]) {
          obj1.breakfast.push(ts);
        } else if (res > this.computedMealNum.lunch[0] && res < this.computedMealNum.lunch[1]) {
          obj1.lunch.push(ts);
        } else if (res > this.computedMealNum.dinner[0] && res < this.computedMealNum.dinner[1]) {
          obj1.dinner.push(ts);
        }
      });
      finishData.forEach((ts) => {
        let res = moment(ts).hour() * 60 + moment(ts).minute();
        // 6:00 ~~~ 10:30
        if (res > this.computedMealNum.breakfast[0] && res < this.computedMealNum.breakfast[1]) {
          obj.breakfast.push(ts);
        } else if (res > this.computedMealNum.lunch[0] && res < this.computedMealNum.lunch[1]) {
          obj.lunch.push(ts);
        } else if (res > this.computedMealNum.dinner[0] && res < this.computedMealNum.dinner[1]) {
          obj.dinner.push(ts);
        }
      });
      let arr = Object.values(obj);
      let arr1 = Object.values(obj1);
      let arr2 = arr.map((item, index) => {
        if (item.length !== 0 && arr1[index].length !== 0) {
          return (arr1[index].length * 100 / item.length).toFixed(4) + '%';
        } else {
          return 0;
        }
      });
      if (finishData.length > 0 && finishDataManually.length > 0) {
        arr2.push((finishDataManually.length * 100 / finishData.length).toFixed(4) + '%');
      } else {
        arr2.push(0);
      }
      return arr2;
    }
  },
  watch: {
    listQuery: {
      handler () {
        this.getEventLsit();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .btn-wrapper {
    margin-top: 70px;
  }
  .container-wrapper {
    position: relative;
    margin: 0 10px;
    .time-card {
      position: absolute;
      top: 50px;
      right: 0;
    }
    .btn-wrapper {
      position: absolute;
      top: -65px;
      left: 200px;
      z-index: 1000;
    }
  }
}
</style>
